import { useCallback } from 'react';

import { Flex } from '@chakra-ui/react';

import { Input } from '@nocowanie/common-ui/components/atoms/input';

import { MapCenter } from '@app/models';

type MapCenterInputsProps = {
    value: MapCenter;
    onChange: (value: MapCenter) => void;
};

export const MapCenterInputs = ({ value, onChange }: MapCenterInputsProps) => {
    const commonInputProps = {
        size: 'xs' as const,
        type: 'number',
        step: 'any',
        inputMode: 'decimal' as const,
    };

    const handleChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>, field: 'lat' | 'lon') => {
            const val = e.target.value;
            const newCoord = val === '' ? null : Number(val);

            onChange({
                lat: field === 'lat' ? newCoord : (value?.lat ?? null),
                lon: field === 'lon' ? newCoord : (value?.lon ?? null),
            });
        },
        [onChange, value?.lat, value?.lon],
    );

    return (
        <Flex gap={2}>
            <Input
                label="Lat"
                inputProps={{
                    ...commonInputProps,
                    placeholder: '51.246452',
                    value: value?.lat ?? '',
                    onChange: e => handleChange(e, 'lat'),
                }}
            />

            <Input
                label="Lng"
                inputProps={{
                    ...commonInputProps,
                    placeholder: '22.568445',
                    value: value?.lon ?? '',
                    onChange: e => handleChange(e, 'lon'),
                }}
            />
        </Flex>
    );
};
